/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { VbzButton } from '@smiles/voebiz-ui-kit';
import { useForm } from 'react-hook-form';
import queryString from 'query-string';
import ReCAPTCHA from 'react-google-recaptcha';

import { AttachFile } from 'components/AttachFile';
import { ControlledInput, ControlledMessage } from '../../../components';
import { defaultValues } from './mock';
import DropdownList from '../DropdownList';
import { handleKeyPressLettersAndNumbers } from '../../../utils';
import { NoLoggedValuesData } from '../NoLoggedForm/mock';
import { LoVNode } from '../../../utils/types';

type Props = {
  onSubmit: (data: NoLoggedValuesData) => void;
  list: LoVNode[];
  isLoading: boolean;
  recaptchaKey: string;
  setRecaptchaValue: (...args: any[]) => any;
  recaptchaValue: string;
};

export default function LoggedForm({
  onSubmit,
  list,
  isLoading,
  recaptchaKey,
  setRecaptchaValue,
  recaptchaValue,
}: Props) {
  const [btnDisabled, setBtnDisabled] = useState<boolean>(true);
  const recComponent = useRef<any>();
  const { t } = useTranslation('create_attendance');
  const {
    control,
    handleSubmit,
    errors,
    getValues,
    watch,
    formState: { isValid },
    setValue,
    register,
  } = useForm<NoLoggedValuesData>({
    mode: 'onChange',
    defaultValues,
  });

  const urlParams = useMemo(() => queryString.parse(window.location.search), []);

  useEffect(() => {
    const hasValidData = !isValid === false && (recaptchaValue?.length > 1 || urlParams.bpr === '1');
    const btnEnabled = !!hasValidData;
    setBtnDisabled(!btnEnabled);
  }, [recaptchaValue, isValid]);

  const RecaptchaHandleChange = (e: any) => {
    setRecaptchaValue(e);
  };

  useEffect(() => {
    register('attachments');
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="matac__section">
        <div className="matac__section__title">
          <span className="text">Dados da solicitação</span>
        </div>
        <DropdownList
          control={control}
          errors={errors}
          list={list}
          watch={watch}
          getValues={getValues}
          setValue={setValue}
        />
        <ControlledInput
          name="reservationCode"
          data-testid="vbz-reservation-code"
          control={control}
          placeholder={t('reservationCodePlaceholder')}
          textLabel={t('reservationCode')}
          error={Boolean(errors.reservationCode)}
          onKeyDown={handleKeyPressLettersAndNumbers}
          errorMessage={t('reservationCodeErrorMessage')}
          rules={{ pattern: /^[a-z0-9]+$/i }}
        />
        <ControlledMessage control={control} errors={Boolean(errors.message)} />
        <AttachFile setValue={setValue} />
        <div data-testid="vbz-proposal-recaptcha">
          <ReCAPTCHA
            ref={recComponent}
            size="normal"
            onExpired={() => setRecaptchaValue('')}
            sitekey={recaptchaKey}
            onChange={RecaptchaHandleChange}
          />
        </div>
        <VbzButton
          text={t('submitButton')}
          type="submit"
          disabled={btnDisabled}
          className="matac_button"
          isLoading={isLoading}
        />
      </div>
    </form>
  );
}
